import colorTokens from './tokens/color-tokens';
import spacingTokens from './tokens/spacing-tokens';
import typographyTokens from './tokens/typography-tokens';
import breakpoints from './tokens/breakpoints';
import { Theme } from './theme';

/** 
  Tokens are CSS values (variables in Sass),
  patterns are combinations of related properties and tokens that are used together,
  constants are both
*/
const styleConstants: Theme = {
  breakpoints,
  colorTokens,
  typographyTokens,
  spacingTokens,
  colorPatterns: {
    button: {
      primary: {
        text: colorTokens.gray['0'],
        background: colorTokens.primary['500'],
      },
      secondary: {
        text: colorTokens.gray['0'],
        background: colorTokens.secondary['700'],
      },
      outline: {
        text: colorTokens.aliases.text,
        background: colorTokens.gray['0'],
        border: colorTokens.aliases.text
      },
    },
    tab: {
      primary: {
        background: colorTokens.primary['500'],
      },
    },
    message: {
      info: {
        background: colorTokens.primary['300'],
        border: colorTokens.primary['500']
      },
      error: {
        background: colorTokens.secondary['200'],
        border: colorTokens.secondary['400']
      },
    },
    heading: {
      main: {
        text: colorTokens.gray['900'],
      },
    },
    pageHeader: {
      main: {
        text: colorTokens.gray['0'],
        background: colorTokens.primary['500'],
      },
    }
  },
  typographyPatterns: {
    body: typographyTokens['500'],
    pageHeader: {
      ...typographyTokens['600'],
      fontWeight: 'bold'
    },
    pageTitle: {
      ...typographyTokens['600'],
      fontWeight: 'bold',
      medium: {
        ...typographyTokens['800'],
      }
    },
    controlCode: {
      ...typographyTokens['800'],
      fontWeight: 'bold',
    },
    button: {
      ...typographyTokens['500'],
      fontWeight: 'bold'
    },
  },
  spacingPatterns: {
    button: {
      padding: spacingTokens.gamma,
    },
    pageHeader: {
      padding: spacingTokens.gamma,
      medium: {
        paddingInline: spacingTokens.gamma,
        paddingBlock: spacingTokens.gamma,
      }
    },
    pageFooter: {
      marginTop: '88px',
      marginBottom: '38px',
      medium: {
        marginTop: '100px',
        marginBottom: '74px', 
      }
    }
  },
  borderRadius: '8px',
  borderWidth: '2px',
};

export default styleConstants;
